import React from 'react';
import styled from 'styled-components'
import FilterList from './FilterList';

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-self: stretch;
    
    overflow-y: scroll;
` 

const MetricsFilterElements = () => {

    return ( 
        <>
            <MainContainer
                 data-tut="filter-elements"
            >
                <FilterList/>
            </MainContainer>
        </>
     );
}
 
export default MetricsFilterElements;